"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandaloneTile = exports.Renderer = void 0;
const Renderer_1 = __importDefault(require("./Renderer"));
exports.Renderer = Renderer_1.default;
const StandaloneTile_1 = __importDefault(require("./StandaloneTile"));
exports.StandaloneTile = StandaloneTile_1.default;
exports.default = Renderer_1.default;
//# sourceMappingURL=index.js.map